import React from 'react';
import styled from 'styled-components';

const ColorLine = ({ color }) => (
  <svg viewBox="0 0 40 10" style={{ width: 40, height: 10 }}>
    <rect width={30} y={3} height={4} fill={color} />
  </svg>
);

const Wrapper = styled.div`
  font-family: Ubuntu,arial;
  margin-bottom: 20px;
  background: transparent;
  padding: 30px;

  .title {
    font-size: 16px;
    color: #707070;
    font-weight: 500;
    margin-bottom: 15px;
    text-align: center;
  }
  .item {
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #606060;
    width: 190px;
    float: left;
    white-space: nowrap;
  }
  .bordered {
    font-size: 12px;
    font-weight: 400;
    display: flex;
    justify-content: center;
  }
`;

export const ChartLegend = ({ colors, titles }) => (
  <Wrapper className="chart-legend">
    <div style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px', textAlign: 'center'}}>
      Hover over the dotted lines on the graph to see the equity retained at that point
    </div>
    <div className="bordered" style={{marginTop: '16px'}}>
      {Object.keys(titles).map(id => (
        <div key={id} className="item" style={{fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px'}}>
          <ColorLine color={colors[id]} />
          {titles[id]}
        </div>
      ))}
    </div>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/ChartLegend.js